module.exports = __webpack_public_path__ + "img/公众号二维码.830d3d75.png";